<template>
  <div
    :class="[
      color ? `bg-${color}-100 border-${color}-500 notice-${color}` : '',
      $i18n.locale == 'fa' ? 'border-r-4' : 'border-l-4',
    ]"
    class="p-4 relative rounded-md shadow-md text-sm text-gray-800 leading-5"
  >
    <p>
      <b v-if="noTitle" class="ml-2"> {{ $t("ATTENTION") }} </b>
      <slot></slot>
    </p>
  </div>
</template>
<script>
export default {
  props: {
    color: {
      type: String,
      default: "yellow",
    },
    noTitle: {
      type: Boolean,
      default: true,
    },
  },
};
</script>
<style lang="scss" scoped>
.notice-yellow {
  @apply bg-yellow-100 border-yellow-500;
}
</style>
